// src/pages/SuccessPage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppContext } from '../../context/AppContext';
import { HeaderTrans, OnlineClubTrans, ScheduleTrans, SuccessTrans, ToasterTrans } from '../../utils/translations';
import PayRub from "../../assets/images/pay1.png";
import PayShek from "../../assets/images/pay2.png";
import { getPassTypes, purchasePass } from '../../services/passService';
import { createYooKassaSubscription, createYooKassaPayment } from '../../services/paymentService';
import { getPolicy } from '../../services/policyService';
import { getUser, updateUser } from '../../services/userService';
import PolicyModal from '../Schedule/PolicyModal';
import OnlineClubFlipCardsGrid from '../onlineClub/OnlineClubFlipCardsGrid';
import ApproxPrice from '../ui/ApproxPrice';
import { useOnlinePrices, ILS_SINGLE_PASS_TYPE_ID, RUB_SINGLE_PASS_TYPE_ID } from '../../hooks/useOnlinePrices';
import '../../styles/landing.css';
import '../../styles/individual-landing.css';


export default function Subscribe() {
    const { user, language, setToaster, setLoading, setUser, onlineClubContent, token, premiumRoles, isMobile } = useAppContext();
    const [rulesAgreedChecked, setRulesAgreedChecked] = useState(false);
    const [currentPolicy, setCurrentPolicy] = useState(null);
    const [showPolicyModal, setShowPolicyModal] = useState(false);
    const [ilsOnlineClubPassTypeId, setIlsOnlineClubPassTypeId] = useState(null);
    const [rubOnlineClubPassTypeId, setRubOnlineClubPassTypeId] = useState(null);
    const [planType, setPlanType] = useState('subscription'); // 'subscription' | 'single'
    const { loginWithRedirect } = useAuth0();
    const onlinePrices = useOnlinePrices();
    const shownPrice = planType === 'subscription' ? onlinePrices.club : onlinePrices.single;

    const details = ScheduleTrans[language];
    const policyTitle = details.firstPassRulesTitle;
    const policyContent = currentPolicy
        ? (language === "russian" ? currentPolicy.contentRu : currentPolicy.contentEn) || details.firstPassRulesContent
        : details.firstPassRulesContent;
    const policy = user?.policyAgreements;
    const showRulesCheckbox = !!(
        user &&
        (!policy?.agreedAt || (currentPolicy && policy?.version !== currentPolicy.version))
    );

    useEffect(() => {
        getPolicy().then(setCurrentPolicy).catch(() => { });
    }, []);

    /** The Online Club product is a PassType flagged onlineOnly, one per currency (ILS / RUB). */
    useEffect(() => {
        getPassTypes({ all: true })
            .then((list) => {
                const onlineClubTypes = (Array.isArray(list) ? list : []).filter((pt) => pt.onlineOnly);
                setIlsOnlineClubPassTypeId(onlineClubTypes.find((pt) => pt.currency === 'ILS')?._id || null);
                setRubOnlineClubPassTypeId(onlineClubTypes.find((pt) => pt.currency === 'RUB')?._id || null);
            })
            .catch(() => {});
    }, []);

    // useEffect(() => {
    //     if (!user) {
    //         window.localStorage.setItem("redirectTo", "/subscribe");
    //         loginWithRedirect({ ui_locales: navigator.language || "ru" });
    //     }
    // if (premiumRoles.includes(user?.role)) {
    //     setToaster({
    //         message: ToasterTrans[language].alreadySubscribed,
    //         type: "success",
    //         show: true,
    //     })
    //     setTimeout(() => {
    //         window.location.assign("/")
    //     }, 4000);
    // };
    // }, [user])

    /** Israel/international card: purchasePass (same flow as Schedule purchase modal). */
    const handleIsraelInternationalPurchase = async (e) => {
        e.preventDefault();
        if (premiumRoles.includes(user?.role) && user?.role !== 'admin') {
            setToaster({
                message: ToasterTrans[language].alreadySubscribed,
                type: "success",
                show: true,
            })
            setTimeout(() => {
                window.location.assign("/")
            }, 4000);
            return;
        };
        if (!user) {
            window.localStorage.setItem("redirectTo", "/subscribe");
            loginWithRedirect({ ui_locales: navigator.language || "ru" });
            return;
        }
        if (showRulesCheckbox && !rulesAgreedChecked) {
            setToaster({ message: details.firstPassRulesAgreementRequired, type: "error", show: true });
            return;
        }
        const isSubscription = planType === 'subscription';
        const passTypeId = isSubscription ? ilsOnlineClubPassTypeId : ILS_SINGLE_PASS_TYPE_ID;
        if (!passTypeId) {
            setToaster({ message: "Failed to load pass options. Please try again.", type: "error", show: true });
            return;
        }
        try {
            setLoading(true);
            if (showRulesCheckbox && rulesAgreedChecked) {
                await updateUser(token, {
                    policyAgreements: {
                        ...user?.policyAgreements,
                        agreedAt: new Date().toISOString(),
                        ...(currentPolicy?.version != null && { version: currentPolicy.version }),
                    },
                });
                const updatedUser = await getUser(token);
                setUser(updatedUser);
            }
            const response = await purchasePass(passTypeId, token, isSubscription, null);
            if (response?.paymentUrl) {
                setLoading(false);
                window.location.href = response.paymentUrl;
                return;
            }
            setLoading(false);
            setToaster({
                message: language === "russian" ? "Не удалось создать оплату. Попробуйте снова или напишите на anna.joy.inbox@gmail.com." : "Failed to create payment. Please try again or contact anna.joy.inbox@gmail.com.",
                type: "error",
                show: true,
            });
        } catch (error) {
            console.error("Error subscribing", error);
            setLoading(false);
            setToaster({
                message: "Ошибка при оформлении подписки. Пожалуйста, попробуйте снова или напишите на anna.joy.inbox@gmail.com.",
                type: "error",
                show: true,
            });
        }
    };

    const handleYooKassaSubscription = async (e) => {
        e.preventDefault();
        if (premiumRoles.includes(user?.role) && user?.role !== 'admin') {
            setToaster({
                message: ToasterTrans[language].alreadySubscribed,
                type: "success",
                show: true,
            })
            setTimeout(() => {
                window.location.assign("/")
            }, 4000);
            return;
        };
        if (!user) {
            window.localStorage.setItem("redirectTo", "/subscribe");
            loginWithRedirect({ ui_locales: navigator.language || "ru" });
            return;
        }
        if (showRulesCheckbox && !rulesAgreedChecked) {
            setToaster({ message: details.firstPassRulesAgreementRequired, type: "error", show: true });
            return;
        }
        const isSubscription = planType === 'subscription';
        const passTypeId = isSubscription ? rubOnlineClubPassTypeId : RUB_SINGLE_PASS_TYPE_ID;
        if (!passTypeId) {
            setToaster({ message: "Failed to load pass options. Please try again.", type: "error", show: true });
            return;
        }
        try {
            setLoading(true);
            if (showRulesCheckbox && rulesAgreedChecked) {
                await updateUser(token, {
                    policyAgreements: {
                        ...user?.policyAgreements,
                        agreedAt: new Date().toISOString(),
                        ...(currentPolicy?.version != null && { version: currentPolicy.version }),
                    },
                });
                const updatedUser = await getUser(token);
                setUser(updatedUser);
            }
            const createPayment = isSubscription ? createYooKassaSubscription : createYooKassaPayment;
            const data = await createPayment({
                successUrl: `${window.location.origin}/successfulPayment`,
                passTypeId,
            }, token);
            setLoading(false);
            if (data?.paymentUrl) {
                window.location.assign(data.paymentUrl);
                return;
            }
            setToaster({
                message: language === "russian" ? "Не удалось создать оплату. Попробуйте снова или напишите на anna.joy.inbox@gmail.com." : "Failed to create payment. Please try again or contact anna.joy.inbox@gmail.com.",
                type: "error",
                show: true,
            });
        } catch (error) {
            console.error("Error subscribing", error);
            setLoading(false);
            const serverMessage = error.response?.data?.error;
            const isAlreadySubscribed = error.response?.status === 409;
            setToaster({
                message: isAlreadySubscribed && serverMessage
                    ? (language === "russian" ? "У вас уже есть активная подписка на этот тариф." : serverMessage)
                    : (language === "russian" ? "Ошибка при оформлении подписки. Пожалуйста, попробуйте снова или напишите на anna.joy.inbox@gmail.com." : "Error subscribing. Please try again or contact anna.joy.inbox@gmail.com."),
                type: "error",
                show: true,
            });
        }
    };

    // Eyebrow label + serif title, same as the individual classes / online club landings
    const eyebrow = (label) => (
        <div className="flex items-center gap-3 text-eyebrow font-sans uppercase tracking-[0.18em] text-clay mb-4">
            <span className="w-6 h-px bg-clay flex-shrink-0" />
            {label}
        </div>
    );
    const titleStyle = { fontSize: 'clamp(32px, 4.5vw, 52px)' };

    return (
        <main className="landing-page min-h-screen w-full font-sans antialiased bg-warm-white">
            {/* Intro */}
            <section className="relative bg-cream pt-32 pb-20 md:pt-[150px] md:pb-24 px-6 md:px-20 overflow-hidden ind-grain">
                <div className="ind-blob w-[min(520px,90vw)] h-[min(520px,90vw)] -top-20 -right-24 bg-clay" />
                <div className="ind-blob w-80 h-80 bottom-10 left-[-4rem] bg-sage-light ind-float-slow" />
                <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start relative z-10 text-left">
                    <div>
                        <div className="animate-fade-up flex items-center gap-3 text-eyebrow font-sans font-normal uppercase tracking-[0.18em] text-clay mb-7" style={{ animationDelay: '0.08s' }}>
                            <span className="w-10 h-px bg-gradient-to-r from-clay to-transparent flex-shrink-0" />
                            {OnlineClubTrans[language].onlineClub}
                        </div>
                        <h1 className="font-serif font-medium leading-[1.05] text-ink mb-8 animate-fade-up" style={{ fontSize: 'clamp(40px, 6vw, 72px)', animationDelay: '0.15s' }}>
                            {SuccessTrans[language].registration}
                        </h1>
                        <p className="text-lg md:text-xl font-sans font-light leading-relaxed text-ink-mid max-w-[560px] animate-fade-up border-l-2 border-clay/40 pl-6" style={{ animationDelay: '0.28s' }}>
                            {SuccessTrans[language].welcome2}
                        </p>
                    </div>
                    <div className="relative animate-fade-up" style={{ animationDelay: '0.35s' }}>
                        <div className="absolute -inset-1 bg-gradient-to-br from-clay/20 via-transparent to-sage-light/20 rounded-2xl blur-sm" />
                        <div className="relative bg-white border border-sand-dark/40 rounded-2xl p-8 md:p-9 shadow-sm">
                            <p className="text-[15px] md:text-base font-sans font-light leading-relaxed text-ink-mid">{SuccessTrans[language].membership}</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* What's included — same cards as Online Club */}
            <section className="py-24 md:py-28 px-6 md:px-20 bg-warm-white relative">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sand-dark to-transparent opacity-60" />
                <div className="max-w-6xl mx-auto text-left">
                    {eyebrow(HeaderTrans[language].whatsIncluded)}
                    <h2 className="font-serif font-medium leading-tight text-ink mb-14 max-w-3xl" style={titleStyle}>
                        {OnlineClubTrans[language].formatsTitle}
                        <em className="italic text-clay">{OnlineClubTrans[language].formatsTitleEm}</em>
                    </h2>
                    <OnlineClubFlipCardsGrid
                        items={onlineClubContent}
                        language={language}
                        isMobile={isMobile}
                        setToaster={setToaster}
                    />
                </div>
            </section>

            {/* Choose payment option */}
            <section className="py-24 md:py-28 px-6 md:px-20 bg-cream relative overflow-hidden ind-grain">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sand-dark to-transparent opacity-60" />
                <div className="max-w-4xl mx-auto">
                    <div className="text-left">
                        {eyebrow(HeaderTrans[language].prices)}
                        <h2 className="font-serif font-medium leading-tight text-ink mb-10" style={titleStyle}>
                            {SuccessTrans[language].dust}
                        </h2>
                    </div>

                    <div className="flex justify-center mb-8">
                        <div className="inline-flex p-1 rounded-full bg-white border border-sand-dark/60 shadow-sm">
                            {[
                                { key: 'single', label: SuccessTrans[language].planToggleSingle },
                                { key: 'subscription', label: SuccessTrans[language].planToggleSubscription },
                            ].map(({ key, label }) => (
                                <button
                                    key={key}
                                    type="button"
                                    onClick={() => setPlanType(key)}
                                    className={`px-5 py-2 rounded-full text-sm font-sans transition ${planType === key
                                        ? "bg-clay text-white shadow-md"
                                        : "text-ink-mid hover:text-clay"
                                        }`}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="text-center mb-12">
                        <p className="font-serif text-4xl md:text-5xl font-normal leading-none text-clay">
                            <ApproxPrice
                                eur={shownPrice.eur}
                                charges={[{ amount: shownPrice.ils, currency: 'ILS' }, { amount: shownPrice.rub, currency: 'RUB' }]}
                                subClassName="mt-3 leading-normal text-ink-light"
                            />
                        </p>
                        <p className="text-xs font-sans font-light text-ink-light mt-2">
                            {planType === 'subscription' ? OnlineClubTrans[language].perMonth : OnlineClubTrans[language].singlePass}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
                        {[
                            { title: SuccessTrans[language].interCard, img: PayRub, action: handleIsraelInternationalPurchase },
                            { title: SuccessTrans[language].rusCard, img: PayShek, action: handleYooKassaSubscription },
                        ].map((item, idx) => (
                            <button
                                key={idx}
                                type="button"
                                onClick={item.action}
                                disabled={showRulesCheckbox && !rulesAgreedChecked}
                                className="group bg-white rounded-2xl border border-sand-dark/50 p-8 md:py-10 text-center shadow-lg transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl hover:border-clay/25 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 flex flex-col items-center justify-center"
                            >
                                <img src={item.img} alt={item.title} className="rounded-full w-24 h-24 object-cover mb-5 ring-4 ring-cream group-hover:ring-clay/15 transition" />
                                <h3 className="font-serif text-xl font-medium text-ink">{item.title}</h3>
                            </button>
                        ))}
                    </div>

                    {user && showRulesCheckbox && (
                        <div className="mt-8 flex justify-center">
                            <label className="flex items-start gap-3 text-left cursor-pointer max-w-xl p-4 rounded-xl bg-white/70 border border-sand-dark/40">
                                <input
                                    type="checkbox"
                                    checked={rulesAgreedChecked}
                                    onChange={(e) => setRulesAgreedChecked(e.target.checked)}
                                    className="mt-1 w-4 h-4 shrink-0 rounded border-sand-dark text-clay focus:ring-clay"
                                />
                                <span className="text-sm font-sans font-light text-ink-mid leading-snug">
                                    {details.firstPassRulesLabelPrefix}
                                    <span
                                        role="button"
                                        tabIndex={0}
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowPolicyModal(true); }}
                                        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setShowPolicyModal(true); } }}
                                        className="text-clay font-medium underline hover:no-underline focus:outline-none cursor-pointer inline"
                                    >
                                        {details.firstPassRulesLinkText}
                                    </span>
                                    {details.firstPassRulesLabelSuffix ?? ""}
                                </span>
                            </label>
                        </div>
                    )}
                </div>
            </section>

            <PolicyModal
                open={showPolicyModal}
                onClose={() => setShowPolicyModal(false)}
                title={policyTitle}
                content={policyContent}
            />
        </main>
    );
}
